var React = require('react');

function SliderArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.859863 48C1.09214 47.9957 1.31408 47.9026 1.47998 47.74L23.5801 24.6599C23.749 24.486 23.8422 24.2525 23.8398 24.01C23.8367 23.7656 23.7445 23.5307 23.5801 23.3499L1.4502 0.25C1.2906 0.0913838 1.0751 0.00163278 0.850098 0C0.734316 0.00036295 0.619875 0.0254298 0.514648 0.0737305C0.409422 0.122031 0.315504 0.192472 0.239746 0.280029C0.0848167 0.461162 0 0.691579 0 0.929932C0 1.16828 0.0848167 1.3987 0.239746 1.57983L21.7197 24.01L0.239746 46.4299C0.0874638 46.6104 0.00390625 46.8389 0.00390625 47.075C0.00390625 47.311 0.0874638 47.5396 0.239746 47.72C0.403047 47.8891 0.625012 47.9893 0.859863 48Z","fill":"black"}));
}

SliderArrow.defaultProps = {"width":"24","height":"48","viewBox":"0 0 24 48"};

module.exports = SliderArrow;

SliderArrow.default = SliderArrow;
